import { signInUrl, signUpUrl } from 'src/libs/wa/utils/accountWebUrl';

export const authorize = (state: 'signIn' | 'signUp') => {
  if (state === 'signIn') {
    window.location.href = signInUrl(window.location.href);
  }
  if (state === 'signUp') {
    window.location.href = signUpUrl(window.location.href);
  }
};
